export default __webpack_public_path__ + "static/media/labyrinthen-property-02.06e23584.jpg";